<template>
  <div class="operation-item">
      <a-form-model
        ref="ruleForm"
        :model="queryForm"
        layout="horizontal"
        :label-col="{span: 8}"
        :wrapper-col="{span: 16}"
        class="query_form"
      >
        <div v-if="isEnterprise" class="query_form_item">
            <a-form-model-item :rules="[{required: true, message: '请选择服务商', trigger: 'change'}]" label="服务商" prop="tenantId">
               <serviceSelect :value="selectCarrier" :is-default-select="true" @change="handleChange"></serviceSelect>
            </a-form-model-item>
        </div>
      </a-form-model>
    <block-title title="下载模板">
      <a-row class="exportStyle item-content">
        <a-col class="leftStyle" :span="10" :offset="0">
          <div
            :class="typeIndex === ImportType.PLAN_ORDER ? 'radioBox radioBoxActive' : 'radioBox'"
            @click="editTypeIndex(ImportType.PLAN_ORDER)"
          >
          <img v-if="typeIndex === ImportType.PLAN_ORDER" class="activeImg" src="@/assets/img/icon_select.png" alt="">
            <p class="exportTitle">仓配出库计划单</p>
            <p class="skuStyle">
              仓配一体计划单下发WMS进行任务确认
            </p>
            <div
              v-track-click="{trackName:$route.query.menuName?`${$route.query.menuName}-批量导入下单-下载模板-仓配出库计划单`:`批量导入下单-下载模板-仓配出库计划单`}"
              class="batchBtnStyle"
               @click="downloadExcelWareHouseTransport('仓配出库计划单', ImportType.PLAN_ORDER)"
            >
              <img src="@/assets/img/icon/xlsx.png" />
              仓配出库计划单
              <img class="icon_load" :src="typeIndex === ImportType.PLAN_ORDER ? downloadField : downloads" />
            </div>
          </div>
        </a-col>
      </a-row>
    </block-title>
    <block-title v-if="fetchOrganization" title="选择项目">
      <div class="item-content widthStyle">
        <select-dom ref="projectRef" v-model="queryForm.projectId" :list="ProjectList" @checkedList="checkedList" @onSearch="onSearchProject" />
        <div v-if="!projectALLData.length">
          暂无运营项目，马上去
          <a-button style="padding: 0" type="link" @click="toProject">创建运营项目</a-button>
        </div>
      </div>
    </block-title>
    <block-title v-if="fetchWarehouse" title="选择仓库">
      <div class="item-content widthStyle">
        <select-dom ref="warehouseRef" v-model="queryForm.warehouseId" :list="warehouseList" @checkedList="handleCheckedWarehouse" @onSearch="onSearchWarehouse" />
        <div v-if="!warehouseAllList.length">
          暂无仓库
        </div>
      </div>
    </block-title>
    <block-title v-if="fetchWarehouse" title="计划单备注">
      <div class="item-content widthStyle textArea_width">
        <a-textarea v-model="queryForm.remark" :max-length="2000" placeholder="请输入计划单备注" :rows="4" />
      </div>
    </block-title>
    <block-title title="选择文件">
          <div class="item-content">
            <div class="content-upload">
              <a-upload
                :show-upload-list="false"
                :before-upload="beforeUpload"
                @change="handleFileChange"
              >
                <a-button
                 v-track-click="{trackName:$route.query.menuName?`${$route.query.menuName}-批量导入仓配计划单-选择文件`:`批量导入仓配计划单-选择文件`}"
                 class="uploadBtn"
                 :disabled="uploading"
                 type="primary"
                >
                  <img class="uploadStyle" src="@/assets/img/icon/upload.png" alt="">
                  {{selectFileBtnTxt}}
                  </a-button>
              </a-upload>
            </div>
            <p class="upload-tip">单次上传最大不超过10000条数据，文件大小最大不超过10M，文件格式支持xlsx</p>
            <p v-if="file" class="filename">
              <img class="filenameLeft" src="@/assets/img/icon/icon_file.png" alt="">
              {{file.name}}
              <img class="filenameRight" src="@/assets/img/icon/icon_lajitong.png" alt="" @click="removeFile">
            </p>
          </div>
    </block-title>
    <fix-bottom class="create-btns">
      <template slot="button">
        <a-button
          v-track-click="{trackName:$route.query.menuName?`${$route.query.menuName}-批量导入仓配计划单-提交`:`批量导入仓配计划单-提交`}"
          type="primary"
          :disabled="!file || showUploadProgress"
          :loading="uploading"
          @click="handleUpload"
        >提交</a-button>
      </template>
    </fix-bottom>
    <a-modal v-model="visible" title="提交成功">
      <p>请等待几分钟后前往任务跟踪导入结果</p>
      <template slot="footer">
        <a-button key="back" v-track-click="{ trackName: '导入成功-立即查看' }" @click="toTask">
          立即查看
        </a-button>
        <a-button key="submit" type="primary" @click="visible = false">
          知道了
        </a-button>
      </template>
    </a-modal>
    <!-- 模板下载 -->
    <a-modal v-model="downLoadModal" :footer="false" :mask-closable="false">
      <div class="proBox">
        <div class="icon_pic">
          <img src="@/assets/img/icon/pic_download.png" alt="">
        </div>
        <p class="loadText">{{downData.productName}}下单导入模板下载</p>
        <div class="progressStyle">
          <p class="progressTitle">正在{{downData.productName}}模板</p>
          <a-progress
            :stroke-color="{
              from: '#108ee9',
              to: '#87d068',
            }"
            :percent="percent"
            status="active"
          />
        </div>
        <a-button key="submit" @click="downLoadModal = false">
          取消下载
        </a-button>
        <p class="proTips">
          <img src="@/assets/img/icon/icon_notic_line.png" alt="">
          <span>{{downTips}}</span>
        </p>
      </div>
    </a-modal>
  </div>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue'
import downloadField from '@/assets/img/icon/download_field.png'
import downloads from '@/assets/img/icon/download.png'
import {progress, fetchProject,importWareHouseMultiDischargeOrder} from '@/pages/orderManage/api'
import FixBottom from '@/components/fix-bottom/index.vue';
import { getToken } from "@/utils/auth";
import {handleCarrierData} from '@/utils/util'
import { getFileNameSuffix } from "@/utils/handleFile.js";
import serviceSelect from '@/components/selectCarrier/serviceSelect.vue'
import SelectDom from '@/components/select/OrderSelect.vue'
import { getWareHouse } from '@/pages/warehouseOrder/api'
import {ImportType,TEMPLATEURL} from '../../constant'
import Service from "../../../../../env/index";

export default {
  name: 'WarehouseMultiple',
  components: {
    BlockTitle,
    FixBottom,
    serviceSelect,
    SelectDom,
  },
  data() {
    return {
      fileMaxSize: 1024 * 1024 * 10,
      // 文件类型暂时只支持 .xlsx
      fileTypeLimit: [".xlsx"],
      ImportType,
      typeIndex:ImportType.PLAN_ORDER,
      downloadField,
      downloads,
      uploading:false,
      file:null,
      showUploadProgress:true,
      visible:false,
      downData: {},
      queryForm:{},
      downTips: '',
      percent: 0,
      downLoadModal: false,
      taskTime: null,
      taskTimer: null,
      selectCarrier:'',
      isEnterprise:false,
      selectCustomer:{},
      ProjectList:[],
      projectALLData: [],
      fetchOrganization:false,
      fetchWarehouse:false,
      projectName:null,
      warehouseList:[],
      warehouseAllList:[],
    }
  },
  computed:{
    selectFileBtnTxt() {
      return !this.file ? "选择文件" : "重新选择";
    },
  },
  created(){
    const {creditCode,customerCode,tenantName}=this.$store.state.user
    this.isEnterprise=!!creditCode
    if(!this.isEnterprise){
      this.getWareHouse([customerCode],tenantName)
      this.getOrganization()
    }
  },
  methods: {
    toProject() {
      this.$router.push('/organization')
    },
    handleCheckedWarehouse(data){
      this.queryForm.warehouseTenantName = data.tenantName;
      this.queryForm.customerCode = data.shipperCode;
      this.queryForm.customerName = data.shipperName;
    },
    onSearchWarehouse(value){
      this.warehouseList = this.warehouseAllList.filter((e) => {
        return e.label.includes(value)
      })
    },
    checkedList(data) {
      this.queryForm.projectName = data.name;
    },
    onSearchProject(value){
      this.ProjectList = this.projectALLData.filter((e) => {
        return e.label.includes(value)
      })
    },
    async getOrganization(value = null){
      this.fetchOrganization = false
      const {userId, customerCode} = this.$store.state.user
      const accountData = JSON.parse(localStorage.getItem('accountData'))
      const productCode = null;
        const data = {
          accountId: userId,
          relationType: 'DOWN',
          orgType: 'PROJECT',
          accountType: 'CUSTOMER',
          orgNameLike: value,
          relationOrgId:accountData?.id,
          customerCode,
          productCode,
          status:'ENABLE',
        }
        const res = await fetchProject(data)
        this.fetchOrganization = true
      if (res && res.length > 0) {
        const records = res.map(t => ({
          ...t,
          name: t.projectName || t.name,
          code:t.projectCode||t.code
        }))
          this.ProjectList = records.map((e) => {
            let subLabel = ''
            if (e.operationResp?.termName) {
              subLabel = `${e.operationResp.termName}`
            }
            return {
              ...e,
              value: `${e.id}`,
              label: e.name,
              subLabel,
              disabled: !e.enableStatus
            }
          })
        } else {
          this.ProjectList = []
          this.queryForm.projectId='';
          this.checkedList({})
        }
        this.projectALLData = this.ProjectList
    },
    async getWareHouse( customerCodes = null, tenantName = null){
      this.fetchWarehouse = false
      const data = {
          customerCodes,
          tenantName,
          needExcludeDefaultTenant: true
      }
      try {
        const res = await getWareHouse(data,{size:500})
        if(res.length <= 0){
          this.warehouseList = []
          this.queryForm.warehouseId = '';
          this.handleCheckedWarehouse({})
          return
        }
        const wareList=[]
        res.records.forEach(item=>{
          if(!wareList.some(child=>child.tenantId===item.tenantId)){
            wareList.push(item)
          }
        })
        const arr = wareList.map((e) => {
          return {
              ...e,
              label: e.tenantName,
              value: e.tenantId
          }
        })
        // this.queryForm.warehouseId = arr[0].value;
        this.warehouseList = arr
        this.warehouseAllList = arr
        this.fetchWarehouse = true;
      } catch (error) {
        this.fetchWarehouse = false;
      }
    },
    async handleChange(value){
      const {ownerTenantId,customerCode, tenantName} = value
      this.selectCustomer = value;
      this.getWareHouse([customerCode],tenantName)
      this.getOrganization()
      this.$set(this.queryForm,'tenantId',ownerTenantId)
      this.selectCarrier = value.id
    },
    downloadExcelWareHouseTransport(item, type) {
      this.downLoadModal = true
      this.downloadDetails(item, TEMPLATEURL.PLAN_ORDER, type,true)
    },
    editTypeIndex(index) {
      this.$set(this,'typeIndex',index)
    },
    beforeUpload(file) {
      this.file = file;
      this.validateFile(file);
      return false;
    },
    validateFile(file) {
      const { fileMaxSize, fileTypeLimit } = this;
      const fileSize = file.size;
      const fileType = getFileNameSuffix(file.name);

      if (!fileTypeLimit.includes(fileType)) {
        this.file = null;
        this.$message.error("文件格式仅支持xlsx");
        return;
      }
      if (fileSize > fileMaxSize) {
        this.file = null;
        this.$message.error("文件最大不超过10M");
      }
    },
    handleFileChange(fileInfo) {
      if (fileInfo?.file?.length !== 0) {
        this.showUploadProgress = false;
        this.uploadedData = null;
      }
    },
    removeFile(){
      this.file = null
    },
    fakeProgress() {
      this.uploadProgress = 0;
      const timer = setInterval(() => {
        if (this.uploadProgress >= 90) {
          clearInterval(timer);
          return;
        }
        this.uploadProgress += 1;
      }, Math.random() * 600);
      return timer;
    },
    isVaildate (){
      const {projectId,warehouseId} = this.queryForm;
      if(!projectId){
        this.$message.warning('请选择项目')
        return false
      }
      if(!warehouseId){
        this.$message.warning('请选择仓库')
        return false
      }
      return true
    },
    async handleUpload() {
      const {projectId,projectName,warehouseId,warehouseTenantName,customerCode,customerName,remark} = this.queryForm;
      if (!this.isVaildate()) return
      // 根据类型上传
      const { file } = this;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("importScene", 'PLAN_AUDIT_ORDER');
      formData.append("projectId", projectId);
      formData.append("projectName", projectName);
      formData.append("customerCodeAndName", `${customerName}--${customerCode}`);
      formData.append("warehouseCodeAndName", `${warehouseTenantName}--${warehouseId}`);
      if(remark){
         formData.append('remark',remark)
      }
      this.uploading = true;
      this.showUploadProgress = true;
      const timer = this.fakeProgress();
      try {
        const resData = await importWareHouseMultiDischargeOrder(formData)
        this.uploadedData = resData;
        this.visible = true
      } catch (err) {
        this.showUploadProgress = false;
      } finally {
        this.uploading = false;
        this.uploadProgress = 100;
        this.file = null
        this.queryForm.remark =undefined;
        clearInterval(timer);
      }
    },
    toTask(){
      this.visible = false
      this.$router.push('/task')
    },
    downloadDetails(name, url, type = null,downLoadModal=false) {
      const http = new XMLHttpRequest();
      const fromDate = {}
      if (type) {
        fromDate.scene = type
      }
      if(downLoadModal){
        this.taskTime = new Date().getTime()
        fromDate.progressId = this.taskTime
        this.percent = 0
        this.taskTimer = setInterval(this.progress, 100)
      }
      http.open("POST", `${Service.EXPORT_WEB}${url}`);
      http.responseType = "blob";
      http.setRequestHeader("Authorization", getToken());
      http.setRequestHeader("Content-Type", 'application/json');
      if(handleCarrierData()){
        const {isConvertEnterprise,enterpriseCustomer}=handleCarrierData()
        http.setRequestHeader("is_convert_enterprise", isConvertEnterprise);
        http.setRequestHeader("enterprise_customer", JSON.stringify(enterpriseCustomer));
      }
      http.onreadystatechange = () => {
        if (http.status === 200 && http.readyState === 4) {
          const filename = `${name}.xlsx`;
          const blob = new Blob([http.response], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
          });
          const csvUrl = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = csvUrl;
          link.download = filename;
          link.click();
        }
      };
      http.send(JSON.stringify(fromDate));
    },
     progress(){
      progress({
        progressId: this.taskTime
      }).then((res) => {
        this.percent = res.currentProgress
        this.downTips = res.tips
        if(res.currentProgress === 100){
          clearInterval(this.taskTimer)
          this.downLoadModal = false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.radioBox {
  .justify-between {
    .batchBtn {
      background: #F2FBF8;
      border-radius: 4px;
      padding: 10px;
      color: #06B880;
      border: 1px dashed #ebe8e8;
      flex: 1;
      display: flex;
      justify-content: space-between;
      &:last-of-type {
        margin-left: 10px;
      }
      &:hover {
        border: 1px dashed #06B880;
      }
    }
  }
  &.radioBoxActive {
    .justify-between {
      .batchBtn {
        &.isActive {
          border: 1px dashed #06B880;
        }
      }
    }
  }
}
.item-content {
  margin-left: 32px;
  padding-bottom: 56px;
}
.uploadBtn{
  padding: 6px 36px;
}
  .uploadStyle{
    margin-right: 12px;
    vertical-align: bottom;
  }
    .upload-tip {
    margin-top: 16px;
    color: #A9ABAE;
    font-size: 12px;
  }
   .filename {
    width: 536px;
    height: 64px;
    margin-top: 32px;
    border-radius: 4px;
    border: 1px solid #E7E9EC;
    font-size: 14px;
    color: #171717;
    line-height: 64px;
    padding: 0 20px 0 27px;
    .filenameLeft{
      margin-right: 28px;
    }
    .filenameRight{
      float: right;
      margin-top: 23px;
      &:hover{
        cursor: pointer;
      }
    }
  }
  .create-btns {
    .align-right {
      .ant-btn {
        height: 48px;
        width: 120px;
        &.ant-btn-primary {
          width: 280px;
        }
      }
    }
  }
.proBox{
  padding: 0 20px;
  text-align: center;
  .icon_pic{
    text-align: center;
  }
  .loadText{
    font-size: 18px;
    text-align: center;
    color: #171717;
    font-weight: bold;
  }
  .progressStyle{
    margin-bottom: 36px;
    .progressTitle{
      font-size: 14px;
      color: #909399;
      text-align: center;
      margin-top: 32px;
    }
  }
  .proTips{
    color: #909399;
    font-size: 14px;
    margin-top: 40px;
    span{
      vertical-align: text-top;
    }
    img{
      vertical-align: sub;
      margin-right: 8px;
    }
  }
}
  .operation-item {
    background: #fff;
    padding-top: 24px;

    &:first-child {
      margin-top: 0;
    }
    .exportStyle {
      width: 80%;
      // padding-left: 32px;
      box-sizing: border-box;
    }
    .mar{
      margin-top: 25px;
    }
  }
  .leftStyle {
    margin-left: 20px;
  }

  .radioBox {
    border: 1px solid rgb(235, 232, 232);
    padding: 40px;
    border-radius: 6px;
    background-color: #F4F5F6;
    &:hover {
      cursor: pointer;
      background: #FFFFFF;
      box-shadow: 0px 18px 19px 0px rgba(207, 232, 224, 0.78);
      border-radius: 6px;
      border: 1px solid #06B880;
      .exportTitle {
        color: #000;
        font-weight: bold;
      }
      .skuStyle {
        color: #7d7b7b;
        span {
          color: #06b880;
        }
      }
      .batchBtnStyle {
        background: #F2FBF8;
        color: #06B880;
        border-radius: 4px;
        border: 1px dashed #06B880;
      }
    }
    .exportTitle {
      color: #000;
      font-size: 14px;
      font-size: 22px;
      line-height: 33px;
      font-weight: bold;
    }
    .skuStyle {
      font-size: 12px;
      color: #bebcbc;
      padding: 10px 0 20px 0;
      line-height: 16px;
      span {
        font-size: 14px;
        color: #06b88071;
        float: right;
      }
    }
    .batchBtnStyle {
      padding: 10px;
      background: #F2FBF8;
      color: #606266;
      border-radius: 4px;
      border: 1px dashed #06B880;
      .icon_load {
        float: right;
        margin-top: 12px;
      }
    }
  }
   .radioBoxActive {
    position: relative;
    background: #FFFFFF;
    box-shadow: 0px 18px 19px 0px rgba(207, 232, 224, 0.78);
    border-radius: 6px;
    border: 1px solid #06B880;
    .exportTitle {
      color: #000;
      font-weight: bold;
    }
    .skuStyle {
      color: #7d7b7b;
      span {
        color: #06b880;
      }
    }
    .batchBtnStyle {
      background: #F2FBF8;
      color: #06B880;
      border-radius: 4px;
      border: 1px dashed #06B880;
    }
  }
  .activeImg{
    position: absolute;
    top: 0px;
    right: 0px;
  }
  .query_form {
  .query_form_item {
  /deep/.ant-form-item-label{
    width: 120px;
  }
 /deep/.ant-form-item-control-wrapper {
    display: inline-flex;
     .ant-form-item-control {
       min-width: 350px;
     }
  }
}
}
.widthStyle{
    width: 456px;
  }
  .textArea_width{
     width: 50%;
  }
</style>
